import styled from 'styled-components';
import { Divider } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { colors } from 'spw-theme';

export const AddCircleIconOnly = styled(AddCircleIcon)`
  && {
    color: ${colors.mainBlue};
    height: 14px;
    width: 14px;
    position: relative;
  }
`;

export const AddCircleIconCustom = styled(AddCircleIconOnly)`
  && {
    margin-right: 5px;
    width: 20px;
    height: 20px;

    &.disabled {
      color: ${colors.mainGray};
    }
  }
`;

export const ProjectDivider = styled(Divider)`
  width: 94%;
`;

export const AddCircleIconCustomDisabled = styled(AddCircleIconCustom)`
  && {
    color: #cbcbcb;
  }
`;
